require(
      "!../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../node_modules/babel-loader/lib/index.js?{\"presets\":[\"/home/pquerna/site/node_modules/babel-preset-react/lib/index.js\",\"/home/pquerna/site/node_modules/babel-preset-es2015/lib/index.js\",\"/home/pquerna/site/node_modules/babel-preset-stage-1/lib/index.js\",[\"/home/pquerna/site/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/home/pquerna/site/node_modules/babel-preset-stage-0/lib/index.js\",\"/home/pquerna/site/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/home/pquerna/site/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/home/pquerna/site/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/home/pquerna/site/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/home/pquerna/site/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./index.js") })
        }
      }, "component---src-pages-slides-index-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=component---src-pages-slides-index-js!./src/pages/slides/index.js
// module id = 324
// module chunks = 231608221292675